import React, { useEffect, useState } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import dayjs from 'dayjs';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import ItemCalenderTimeEx from '../../atoms/Calendar/ItemCalenderTimeEx';
import { RT_TRD_GROUP_SET } from '../../../function/GroupDataModel';
import RealTimeTrendGraphPageComboBox from './RealTimeTrendGraphPageComboBox';
import RealTimeTrendGraphItemInfoHeader from './RealTimeTrendGraphItemInfoHeader';
import RealTimeTrendGraphChart, { ChartInitType } from './RealTimeTrendGraphChart';
import {
  RealTimeTrendSettingModel,
  CreateDefaltRealTimeTrendSettingModel,
  GetRealTimeTrendSettingModelList,
} from './RealTimeTrendGraph';
import RealTimeTrendGraphItemInfoList from './RealTimeTrendGraphItemInfoList';
import RealTimeTrendGraphButtonList from './RealTimeTrendGraphButtonList';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../function/useModal';
import RealtimeSettingDialog, { RealtimeSettingDialogResponse } from '../../molecules/Dialog/RealtimeSettingDialog';
import RangeInputNumber from '../../molecules/Range/RangeInputNumber';

const useStyles = makeStyles(
  createStyles({
    responsiveContainer: {
      minHeight: 'calc(100vh - 440px)',
      maxHeight: 'calc(100vh - 440px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    labelStyle: {
      fontSize: '15px',
    },
  })
);

const createDefaltTrandSettingData = (count: number): RealTimeTrendSettingModel[] => {
  var list: RealTimeTrendSettingModel[] = [];
  for (let i = 0; i < count; i++) {
    list.push(CreateDefaltRealTimeTrendSettingModel());
  }
  return list;
};

type Props = {
  location: { state: RT_TRD_GROUP_SET };
};

const RealTimeTrendGraphPage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const selectDay: string = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
  console.debug(['--- selectDay', selectDay]);

  const [chartInitData, setChartInitData] = useState<ChartInitType>({
    selectGroupNo: 0,
    targetDay: '',
    trendSettingList: [],
  });

  //画面選択中のグループ番号
  const [selectGroupNo, setSelectGroupNo] = useState<number>(
    props.location.state != undefined ? props.location.state.GROUP_NO : 1
  );

  //カーソル日付
  const [targetDay, setTargetDay] = useState<string>(selectDay);

  const [trendSettingList, setTrendSettingList] = useState<RealTimeTrendSettingModel[]>(
    createDefaltTrandSettingData(8)
  ); //画面選択中のグループアイテム

  const [flgRTTDlg, actRTTDlg] = useModal<RealtimeSettingDialogResponse>();

  const [yMax, setYMax] = useState<number>(0);
  const [yMin, setYMin] = useState<number>(0);

  const onYMinMaxChange = (min: number, max: number) => {
    if (min == Infinity) {
      return;
    }
    if (max == Infinity) {
      return;
    }
    console.debug(['min max', min, max]);
    setYMax(max);
    setYMin(min);
  };

  useEffect(() => {
    GetRealTimeTrendSettingModelList(selectGroupNo.toString()).then((result) => {
      console.log(['GetRealTimeTrendSettingModelList - useEffect', result]);
      //左側アイテムをデフォルト選択
      if (result.length && result[0].PLCNo !== '0') {
        result.forEach((row) => (row.IsRowSelect = false));
        result[0].IsRowSelect = true;
      }
      setTrendSettingList([...result]);
      setChartInitData({ selectGroupNo: selectGroupNo, targetDay: targetDay, trendSettingList: result });
    });
  }, [selectGroupNo]);

  const changeGroupSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setSelectGroupNo(Number(event.target.value));
  };

  const changeTrendSettingData = (datas: RealTimeTrendSettingModel[]) => {
    //console.log(["★★★datas", datas]);
    setTrendSettingList([...datas]);
  };

  //リアルタイムトレンドダイアログ
  const showRealTimeTrendSettingDialog = () => {
    console.debug(['★ showRealTimeTrendSettingDialog ★', selectGroupNo]);

    actRTTDlg
      .open()
      .apply((resp) => {
        console.debug(['apply()', resp]);
        GetRealTimeTrendSettingModelList(selectGroupNo.toString()).then((result) => {
          //console.log(['GetRealTimeTrendSettingModelList - actRTTDlg', result]);
          //左側アイテムをデフォルト選択
          if (result.length && result[0].PLCNo !== '0') {
            result.forEach((row) => (row.IsRowSelect = false));
            result[0].IsRowSelect = true;
          }
          setTrendSettingList([...result]);
          setChartInitData({ selectGroupNo: selectGroupNo, targetDay: targetDay, trendSettingList: result });
        });
      })
      .cancel((resp) => {
        //console.debug(['cancel()',]);
      });
  };
  const rttdlg = flgRTTDlg ? <RealtimeSettingDialog dialog={actRTTDlg} groupNo={selectGroupNo} /> : null;

  const changeCalendarValue = (value: string) => {
    console.debug(['★changeCalendarValue★', value]);
    setTargetDay(value);
    setChartInitData({ selectGroupNo: selectGroupNo, targetDay: value, trendSettingList: trendSettingList });
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <div style={{ width: 10 }}></div>
        <RealTimeTrendGraphPageComboBox onChangeEvent={changeGroupSelect} defalutIndex={selectGroupNo} />
        <div style={{ width: 50 }}></div>
        <ItemCalenderTimeEx
          label={t('RealTimeTrendGraphPage.カーソル日付', 'カーソル日付：')}
          labelPosition={1}
          textCssString={classes.labelStyle}
          labelCssString={classes.labelStyle}
          defaultValue={targetDay}
          onChange={changeCalendarValue}
        />
        <div style={{ width: 50 }}></div>
        <RangeInputNumber
          textBoxWidth={'70px'}
          label={t('RealTimeTrendGraphPage.グラフ縦軸範囲', 'グラフ縦軸範囲')}
          minValue={yMin}
          maxValue={yMax}
          maxValueLimit={999999}
          minValueLimit={0}
          onChange={onYMinMaxChange}
        />
      </Box>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 0 }}>
        <Grid item xs={3} style={{ fontSize: '0.8em' }}></Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={5}></Grid>

        <Grid item xs={1} style={{ fontSize: '0.7em' }}>
          <RealTimeTrendGraphItemInfoHeader />
        </Grid>
        <Grid item xs={11} style={{ fontSize: '0.7em' }}>
          <RealTimeTrendGraphItemInfoList
            trendSettingList={trendSettingList}
            selectGroupNo={selectGroupNo}
            onChangeTrandSettingData={changeTrendSettingData}
            onshowRealTimeTrendSettingDialog={showRealTimeTrendSettingDialog}
          />
        </Grid>
        <Grid item xs={12}>
          <RealTimeTrendGraphChart
            trendSettingList={trendSettingList}
            selectGroupNo={selectGroupNo}
            chartContainerStyle={classes.responsiveContainer}
            chartInitData={chartInitData}
            onYMinMaxChange={onYMinMaxChange}
            yMax={yMax}
            yMin={yMin}
          />
        </Grid>
        <Grid item xs={12}>
          <RealTimeTrendGraphButtonList rTrendSettingList={trendSettingList} />
        </Grid>
        {rttdlg}
      </Grid>
    </div>
  );
};

export default RealTimeTrendGraphPage;
